import {
  ReleasedFeaturesInDate,
  ReleaseNotesService
} from "../../sdServices/release-notes-config/release-notes-service";
import { ReleaseNote } from "../../sdServices/release-notes-config/release-notes-config";
import { FeatureConfigService } from "../../sdServices/feature-config/feature-config";
import { WindowCommunicationBridgeService } from "../../../ShellCommon/eventModule/window-communication-bridge";

export class SdDetailedReleaseNotesContentContoller {
  public releasedFeatures: ReleasedFeaturesInDate;
  public isEaePmOrDev: boolean;

  public readonly DATE_FORMAT: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
  // @ngInject
  constructor(
    private releaseNotesService: ReleaseNotesService,
    private featureConfigService: FeatureConfigService,
    private windowCommunicationBridgeService: WindowCommunicationBridgeService,
    private $window: ng.IWindowService
  ) {
    this.isEaePmOrDev = this.featureConfigService.isEnabled("ServiceDesk", "EAE_PM_OR_DEV");
  }

  public doesReleaseNoteContainHtml(releaseNotes: ReleaseNote[], isFull: boolean): boolean {
    return releaseNotes.some((releaseNote: ReleaseNote) => {
      return isFull ? !!releaseNote.bundleHtmls.fullHtml : !!releaseNote.bundleHtmls.splashHtml;
    });
  }

  public getAppGlyphClass(appId: string): string {
    return this.releaseNotesService.getGlyphFromAppId(appId);
  }

  public forceSplash(): void {
    this.windowCommunicationBridgeService.publish(
      this.releaseNotesService.COMMUNICATION_BRIDGE_FORCE_SPLASH_EVENT_NAME,
      {}
    );
    this.$window.close();
  }
}

export const sdDetailedReleaseNotesContent: ng.IComponentOptions = {
  controller: SdDetailedReleaseNotesContentContoller,
  bindings: {
    releasedFeatures: "<"
  },
  templateUrl: "../ServiceDesk/releaseNotes/detail/sd-release-note-detail-content.html"
};
